import { CustomerGetDto } from '../../api/api-types';
import { GET_CLIENT_DATA } from '../actions';

export const getClientDataAction = (data: CustomerGetDto) =>
  GET_CLIENT_DATA({ payload: data });
